import { render, staticRenderFns } from "./TestCompareView.vue?vue&type=template&id=5deb7e24&scoped=true&"
import script from "./TestCompareView.vue?vue&type=script&lang=js&"
export * from "./TestCompareView.vue?vue&type=script&lang=js&"
import style0 from "./TestCompareView.vue?vue&type=style&index=0&id=5deb7e24&scoped=true&lang=css&"
import style1 from "./TestCompareView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb7e24",
  null
  
)

export default component.exports